// Compatibility wrapper: all available DayOne FC features are free.
export function FeaturePreview() { return null; }
export default function PremiumGate({ children }) { return children; }
